<template>
  <a-drawer
    title="选择师傅"
    :width="720"
    :visible="visible"
    @close="onClose"
  >

    <a-table
      :columns="columns"
      :rowKey="record => record.id"
      :data-source="list"
      :pagination="false"
      :loading="loading"
    >
      <span slot="action" slot-scope="record">
        <a-button type="link" @click="selectMaster(record)">选择</a-button>
      </span>
    </a-table>

    <a-pagination
      style="margin-top: 16px; text-align: right"
      show-quick-jumper
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      @change="changePage"
    />
  </a-drawer>
</template>

<script>
import { fetchMasterList } from '@/api/repairModule/repairMaster'

export default {
  name: 'SelectMasterDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      list: [],
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        type: 2,
        searchKey: '',
      },
      columns: [
        {
          title: '师傅姓名',
          dataIndex: 'nickName',
          key: 'nickName',
          width: 120,
        },
        {
          title: '联系电话',
          dataIndex: 'phoneNumber',
          key: 'phoneNumber',
          width: 140,
        },
        {
          title: '服务区域',
          dataIndex: 'serviceArea',
          key: 'serviceArea',
          width: 200,
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 100,
        },
      ],
    }
  },
  methods: {
    show() {
      this.visible = true
      this.queryParam.pageNum = 1
      this.queryParam.searchKey = ''
      this.getList()
    },
    onClose() {
      this.visible = false
    },
    getList() {
      this.loading = true
      fetchMasterList(this.queryParam).then((response) => {
        this.list = response.data.records || []
        this.total = response.data.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    selectMaster(record) {
      const masterInfo = {
        id: record.id,
        name: record.nickName,
        phone: record.phoneNumber,
      }

      this.$emit('select', masterInfo)
      this.visible = false
    },
    changePage(page, pageSize) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    handleSearch(value) {
      this.queryParam.searchKey = value
      this.queryParam.pageNum = 1
      this.getList()
    },
  },
}
</script>

<style scoped>
</style>
